// --- Ingredient function definitions ---
const ingredientFunctions = {
    "Algae Oil": "A vegetarian source of DHA, supports infant brain and visual development.",
    "Amino Acids": "Building blocks of protein, essential for growth and development.",
    "ARA": "Arachidonic Acid; supports brain, nerve, and eye development in infants.",
    "Ascorbyl Palmitate": "A fat-soluble form of Vitamin C used as an antioxidant.",
    "Beta-Palmitate": "A special fat that improves calcium absorption and gut comfort.",
    "Bifidobacterium Breve M-16V": "A probiotic that supports healthy gut flora in infants.",
    "Biotin": "A B-vitamin important for metabolism, skin, and hair development.",
    "Calcium": "Essential mineral for building strong bones and teeth.",
    "Chloride": "An electrolyte mineral that helps maintain fluid balance.",
    "Choline": "Supports brain and nervous system development.",
    "Citric Acid": "Regulates acidity and acts as a preservative.",
    "Coconut Oil": "Source of healthy fats and medium-chain triglycerides.",
    "Copper": "Supports healthy blood, immune function, and brain development.",
    "Cow Milk": "Primary source of protein and calcium in many infant formulas.",
    "DHA": "Docosahexaenoic Acid; Omega-3 fat important for brain and eye development.",
    "Emulsifiers": "Help blend fats and liquids for a smooth, consistent formula.",
    "Fish Oil": "Rich source of Omega-3 fatty acids like DHA and EPA.",
    "Folic Acid": "Essential for cell growth and brain/spinal development.",
    "Galacto-Oligosaccharides": "Prebiotic fibers that nourish healthy gut bacteria.",
    "Glucose Syrup": "A carbohydrate providing energy for growth.",
    "Inositol": "Important for brain development and cell membrane formation.",
    "Iodine": "Vital for healthy thyroid and brain development.",
    "Iron": "Essential for healthy blood and brain development.",
    "Lactic Acid": "Probiotic that maintains acidity and can act as a preservative.",
    "Lactose": "Primary carbohydrate found in human and cow's milk.",
    "Magnesium": "Supports bone growth, muscle and nerve function.",
    "Maltodextrin": "Easily digestible carbohydrate for energy.",
    "Manganese": "Trace mineral for bone formation and metabolism.",
    "Metafolin": "Bioavailable form of folate, crucial for cell growth.",
    "Mortierella Alpina Oil": "Source of ARA, supports growth and development.",
    "Nicotinamide": "A form of Vitamin B3 important for energy metabolism.",
    "Nucleotides": "Support immune system and healthy cell growth.",
    "Orthophosphoric Acid": "Acidity regulator.",
    "Palm Oil": "Source of fats; helps mimic fat in breast milk.",
    "Phosphorus": "Supports bone and tooth development.",
    "Potassium": "Electrolyte for heart, muscle, and nerve function.",
    "Rapeseed Oil": "Healthy fat source rich in omega fatty acids.",
    "Sodium": "Electrolyte mineral important for fluid balance.",
    "Soluble Dextrin": "Carbohydrate for easy energy.",
    "Soybean Oil": "Source of polyunsaturated fats.",
    "Starch": "Carbohydrate that thickens formula and provides energy.",
    "Sunflower Lecithin": "Emulsifier and source of choline.",
    "Sunflower Oil": "Source of healthy fats and Vitamin E.",
    "Taurine": "Supports eye, brain, and nerve development.",
    "Thickener": "Improves formula consistency for easier feeding.",
    "Vitamin A": "Supports vision and immune health.",
    "Vitamin B": "Family of B vitamins for energy and cell health.",
    "Vitamin B1": "Thiamine; essential for nervous system development.",
    "Vitamin B12": "Cobalamin; supports blood and nerve health.",
    "Vitamin B2": "Riboflavin; important for growth and energy.",
    "Vitamin B3": "Niacin; supports metabolism and energy production.",
    "Vitamin B5": "Pantothenic Acid; helps convert food to energy.",
    "Vitamin B6": "Pyridoxine; aids brain and immune development.",
    "Vitamin C": "Boosts immunity and acts as an antioxidant.",
    "Vitamin D3": "Helps build strong bones and supports calcium absorption.",
    "Vitamin E": "Antioxidant that protects cells and supports immunity.",
    "Vitamin K": "Vital for normal blood clotting and bone health.",
    "Whey Powder": "Milk protein, easy to digest and supports growth.",
    "Zinc": "Supports immune function, growth, and development."
};